import { render, staticRenderFns } from "./DriveLogDetail.vue?vue&type=template&id=f0fdbf4c"
import script from "./DriveLogDetail.vue?vue&type=script&lang=js"
export * from "./DriveLogDetail.vue?vue&type=script&lang=js"
import style0 from "./DriveLogDetail.vue?vue&type=style&index=0&id=f0fdbf4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports